import React, { useMemo } from 'react'

import { useQuery } from '@apollo/client'
import { Box, CssBaseline } from '@mui/material'

import Drawer from './Drawer'
import EnterprisePlanReport from './EnterprisePlanReport'
import EnterprisePlans from './EnterprisePlans'
import { EnterprisePlansDocument } from '../../../__generated__/graphql'

export default function Enterprise({
  enterprisePlanId,
}: {
  enterprisePlanId: string | null
}) {
  const { data: allPlans, loading: loadingAllPlans } = useQuery(
    EnterprisePlansDocument,
  )

  const enterprisePlanIdInt: number | null = useMemo(() => {
    if (!enterprisePlanId) {
      return null
    }
    try {
      return parseInt(enterprisePlanId, 10)
    } catch (_error) {
      return null
    }
  }, [enterprisePlanId])

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Drawer allPlans={allPlans} loading={loadingAllPlans} />
      <Box
        component="main"
        // 63px is height of admin header in Flask template
        sx={{ flexGrow: 1, minHeight: 'calc(100vh - 63px)', p: 3 }}
      >
        {!enterprisePlanIdInt && (
          <EnterprisePlans allPlans={allPlans} loading={loadingAllPlans} />
        )}
        {enterprisePlanIdInt && (
          <EnterprisePlanReport enterprisePlanId={enterprisePlanIdInt} />
        )}
      </Box>
    </Box>
  )
}
